import React, { FC } from 'react'

interface IProps {
  categoryNo: string;
  style?: { [key: string]: any };
}

const CategoryItem: FC<IProps> = ({ categoryNo, style }) => {
  return (
    <div
      className='category-item'
      id={`category-item-${categoryNo}`}
      data-id={`category-${categoryNo}`}
      style={style || { visibility: 'hidden' }}
    >
    </div>
  )
}
export default CategoryItem
